"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProportionFromToken = function (token) {
    var proportions = token.split(':');
    var width = parseInt(proportions[0]);
    var height = parseInt(proportions[1]);
    return height / width;
};
